import classNames from 'classnames';

import type { ContentGateElementProps } from './ContentGate.types';

export function ContentGateElement(props: ContentGateElementProps) {
  const { children, attributes } = props;

  return (
    <div {...attributes} className={classNames('flex flex-col h-auto relative')}>
      {children}
    </div>
  );
}
